import React from 'react';
import { RangeValue } from 'rc-picker/lib/interface';
import moment, { Moment } from 'moment';
import { CloseCircleOutlined } from '@ant-design/icons';
import { DatePicker } from 'antd';
import { useAppDispatch } from 'app/config/store';
import { resetDates } from './finance.reducers';
const { RangePicker } = DatePicker;

type CustomRangePickerProps = {
  startDate: string | null;
  endDate: string | null;
  onChange?: (dates: RangeValue<Moment>, dateStrings: [string, string]) => void;
};

const CustomRangePicker: React.FC<CustomRangePickerProps> = ({ startDate, endDate, onChange }) => {
  const dispatch = useAppDispatch();
  const handleChange = (dates: RangeValue<Moment>, dateStrings: [string, string]) => {
    if (!dates) {
      dispatch(resetDates());
    }

    if (onChange) {
      onChange(dates, dateStrings);
    }
  };
  return (
    <RangePicker
      value={[startDate ? moment(startDate) : null, endDate ? moment(endDate) : null]}
      allowClear
      allowEmpty={[false, false]}
      onChange={handleChange}
      style={{ width: '100%', maxWidth: '400px' }}
      clearIcon={<CloseCircleOutlined style={{ color: '#f5222d', fontSize: '16px' }} />}
    />
  );
};

export default CustomRangePicker;
